import {useEffect, useState} from 'react';
import * as Cesium from 'cesium';
import {CameraFlyTo, useCesium} from 'resium';

import {Vec4} from '../../utils/vec4';
import {useKmzLookAt} from '../../hooks/useKmzLookAt';

export type UpdatePositionProps = {
  position: null | {
    lati: number;
    long: number;
    height: number;
  };
  boundingBox: null | Vec4;
  kmzId2?: number | null;
};

const CameraFlyToCoords: React.FC<UpdatePositionProps> = ({position, boundingBox, kmzId2}) => {
  const {viewer} = useCesium();

  const [destination] = useState<Cesium.Cartesian3 | Cesium.Rectangle | null>(null);

  const kmzPosition = useKmzLookAt(kmzId2 ?? null); // <--- pull LookAt if not passed explicitly
  const finalPosition = position ?? kmzPosition;

  useEffect(() => {
    if (!viewer) return;

    if (finalPosition) {
      const dest = Cesium.Cartesian3.fromDegrees(
        finalPosition.long,
        finalPosition.lati,
        finalPosition.height
      );
      viewer.camera.flyTo({ destination: dest });
    } else if (boundingBox) {
      const [west, north, east, south] = boundingBox;
      const rect = Cesium.Rectangle.fromDegrees(west, south, east, north);
      viewer.camera.flyTo({ destination: rect });
    }
  }, [viewer, finalPosition, boundingBox]);

  if (!destination) return null;
  return <CameraFlyTo destination={destination} />;
};

export default CameraFlyToCoords;
